export type ThemeTokens = {
    primary: string;
    primaryDarker: string;
    primaryLighter: string;
    primaryLightest: string;
    secondary: string;
    secondaryLighter: string;
    secondaryDarker: string;
    accent: string;
    error: string;
    errorLighter: string;
    errorDarker: string;
    textPrimary: string;
    textSecondary: string;
    background: string;
    backgroundSecondary: string;
    borderRadius: string;
    fontFamily: string;
};

/** Tokens crudos del bundle de Experience (`/experience/theme/bundle`). May be flat or nested. */
export type ExperienceThemeTokens = Record<string, unknown>;

export type ExperienceThemeBundle = {
    contentVersion: string;
    appId: string;
    tenantId: string;
    rubric?: string;
    theme: {
        tokens?: ExperienceThemeTokens;
        assets?: Record<string, string>;
    };
};

/** Nombres de CSS custom properties expuestas en `:root`. */
export const THEME_CSS_VARS = {
    primary: '--color-primary',
    primaryDarker: '--color-primary-darker',
    primaryLighter: '--color-primary-lighter',
    primaryLightest: '--color-primary-lightest',
    secondary: '--color-secondary',
    secondaryLighter: '--color-secondary-lighter',
    secondaryDarker: '--color-secondary-darker',
    accent: '--color-accent',
    error: '--color-error',
    errorLighter: '--color-error-lighter',
    errorDarker: '--color-error-darker',
    textPrimary: '--color-text-primary',
    textSecondary: '--color-text-secondary',
    background: '--color-background',
    backgroundSecondary: '--color-background-secondary',
    borderRadius: '--border-radius',
    fontFamily: '--font-family-primary',
} as const satisfies Record<keyof ThemeTokens, string>;
